// extracted by mini-css-extract-plugin
export default {"LabelValueWrapper":"LabelValue_LabelValueWrapper__Wrr6L","Label":"LabelValue_Label__0xHgi","Value":"LabelValue_Value__ccCVT","Link":"LabelValue_Link__Ah4ju"};